/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookCheck: {
  name: 'book-check';
  data: string;
} = {
  name: 'book-check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.515 3.34A2 2 0 0 1 21 5.28v11.94a2 2 0 0 1-1.515 1.94l-7 1.75a1.989 1.989 0 0 1-.142.03.998.998 0 0 1-.686 0 1.989 1.989 0 0 1-.142-.03l-7-1.75A2 2 0 0 1 3 17.22V5.28a2 2 0 0 1 2.485-1.94L12 4.97l6.515-1.63ZM19 17.22l-6 1.5V6.78l6-1.5v11.94ZM5 5.28l6 1.5v11.94l-6-1.5V5.28Zm13.207 5.013a1 1 0 0 0-1.414 0L15.5 11.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0 0-1.414Z" fill="currentColor"/></svg>`,
};
